module.exports = __webpack_public_path__ + "static/media/icon_account_hover-01.1d9a8871.svg";